import { Col, Input, Row, Select, Space, Switch } from "antd";
import {
  COMMON_PATHS,
  findLayersOrLayerAssets,
  getPath,
  IInteractiveModForm,
} from "@blings/blings-player";
import { ModsPanelCompProps } from "../ModsPanel";
import { useMst } from "../../../stores/main";
import { JsEditor } from "../../Editor/JsEditor";
import { LayerSelector } from "../../LayerSelector";
import MainCTAButton from "../../MainCTA/MainCTAButton";
import { InfoTooltip } from "../../../BaseComps/InfoTooltip";
import { useEffect } from "react";
import { sharedInputAllowClear } from "../../antd-extensions/selectClearIcon";

export const DEFAULT_FUNCTION_FOR_EXPRESSION = (
  isControlDeprecated: boolean
) => `(inputs, sessionId, userId, data${
  !isControlDeprecated ? ", liveControlData" : ""
}) => {
  fetch("ENDPOINT", {
    method: "POST",
    body: JSON.stringify({
      sessionId,
      userId,
      data: inputs
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
}`;
export function InputFormForm(props: ModsPanelCompProps<IInteractiveModForm>) {
  const { change, assetLayerPairs, json, onChange, index } = props;
  const { inputKeys } = change;
  const {
    platformStore: { inputNames, isControlDeprecated },
  } = useMst();

  const inputNameOption = inputNames
    .filter((name, index, self) => self.indexOf(name) === index)
    .map((inputName) => (
      <Select.Option key={inputName}>{inputName}</Select.Option>
    ));

  useEffect(() => {
    if (change.ctaName == null) {
      const layers = findLayersOrLayerAssets({
        assetId: change.assetId,
        layerName: change.layerName,
        layerUid: change.layerUid,
        jsonVid: json,
        additionals: change.additionals,
      });
      const layer =
        layers?.length &&
        layers.find((layer) => getPath(layer, COMMON_PATHS.TEXT_IN_LAYER));
      if (layer) {
        const text = getPath(layer, COMMON_PATHS.TEXT_IN_LAYER);
        text && onChange(index, "ctaName", text);
      }
    }
  }, [
    change.ctaName,
    change.assetId,
    change.layerName,
    change.layerUid,
    change.additionals,
    json,
    onChange,
    index,
  ]);

  return (
    <Space direction={"vertical"} style={{ width: "100%" }}>
      <Row>
        <Col style={{ marginBottom: "8px", width: "100%" }}>
          <span style={{ color: "#6E7079", lineHeight: "22px" }}>
            Submit button Layers:
          </span>
          <LayerSelector
            isMulti={true}
            assetLayerPairs={assetLayerPairs}
            selectedAssetId={change.assetId}
            selectedLayerName={change.layerName}
            selectedLayerUid={change.layerUid}
            onChange={props.onLayerChange}
            selectedAdditionals={change.additionals}
            index={index}
            jsonVid={json}
          />
        </Col>
        <Col style={{ width: "100%" }}>
          <span style={{ color: "#6E7079", lineHeight: "22px" }}>
            Name this button (Required for analytics)
          </span>
          <InfoTooltip
            style={{ marginLeft: "5px" }}
            info="This name is used to track how many viewers clicked on the button."
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "25px",
              width: "100%",
            }}
          >
            <Input
              id="connector-cta-name"
              style={{ width: "100% !important" }}
              value={props.change.ctaName}
              // eslint-disable-next-line no-template-curly-in-string
              placeholder="Name this button"
              onChange={(e) => onChange(index, ["ctaName"], [e.target.value])}
              allowClear={sharedInputAllowClear}
            />
          </div>
        </Col>
      </Row>

      <Col>
        <span style={{ color: "#6E7079", lineHeight: "22px" }}>
          Add input fields to be saved on click:
        </span>
        <InfoTooltip
          style={{ marginLeft: "5px" }}
          info="Select the fields to be saved to the database."
        />
        <Select
          placeholder="Choose inputs"
          mode="multiple"
          value={inputKeys}
          onChange={(e) => {
            onChange(index, "inputKeys", e);
          }}
          allowClear
          style={{ width: "100%" }}
        >
          {inputNameOption}
        </Select>
      </Col>

      <Row align="middle">
        <span>Send to Blings</span>
        <Switch
          checked={change.sendToThirdParty}
          onChange={(e) => onChange(index, "sendToThirdParty", e)}
        />
        <span>Customize your own</span>
      </Row>
      {change.sendToThirdParty ? (
        <JsEditor
          defaultValue={
            change.functionString ||
            DEFAULT_FUNCTION_FOR_EXPRESSION(isControlDeprecated)
          }
          onChange={(e) => onChange(index, "functionString", e)}
          runtimeContext="interactiveForm"
        />
      ) : null}
      <MainCTAButton change={change} onChange={onChange} index={index} />
    </Space>
  );
}
